module.exports = __webpack_public_path__ + "img/touxiang.705fb511.png";